import { useParams } from "react-router-dom";
import { Lock } from "lucide-react";
import { PageHeader } from "../components/common";

const INFO = {
  orders: ["Order Management", "Pre-PO → PO → Operations/WIP → Completion → CS. Will migrate 1,736 Order Tracker UIDs (A00001–A01731) with their stages, owners and amounts."],
  operations: ["Operations", "Design approval → Technical drawings → Material planning → Procurement → Fabrication → Finishing → Factory QC → Packing → Dispatch → Installation → Site QC → Client handover."],
  bp: ["BP & Business Planning", "Client × branch (Delhi (FBD) / Mumbai) annual, monthly and weekly plan vs actual, Winning-sheet activity KPIs and Meeting Plan."],
  founder: ["Founder Dashboard", "Consolidated view, plus the 5:35 PM IST daily brief (Mon–Sat) in-app and by email."],
};

export default function Locked() {
  const { mod } = useParams();
  const [t, d] = INFO[mod] || ["Module", ""];
  return (
    <div data-testid={`locked-${mod}`}>
      <PageHeader eyebrow="Planned · later stage" title={t} desc={d} />
      <div className="ax-panel p-10 flex items-center gap-4 text-muted-foreground"><Lock className="h-5 w-5 text-primary" /> This module will be built after you review and approve Stage 1 and the Sales module.</div>
    </div>
  );
}
